export function extractSecondDateFromTitle(str: string): string | null {
  const regex = /(\d{2}\.\d{2}\.\d{4}).*?(\d{2}\.\d{2}\.\d{4})/
  const match = str.match(regex)
  return match ? match[2] : null
}
